export default __webpack_public_path__ + "2394dbaec270054f5d393a9f2427ccb0.png";